import { useEffect, useState, Fragment, useRef } from 'react';
import axios from 'axios';
import ListToggle from './ListToggle';
import { Card, Typography } from "@material-tailwind/react";
import ModalModifyTizenbo from "./ModalModifyTizenbo"
import * as XLSX from 'xlsx';

const ALL_COLUMNS = [
    { key: "_client_name", label: "Nom Client" },
    { key: "status", label: "Statut" },
    { key: "_app_type", label: "Type d'app" },
    { key: "_authorized", label: "Autorisé" },
    { key: "_pin_code", label: "Code PIN" },
    { key: "_end_date", label: "Date de fin", type: "date" },
    { key: "_last_seen", label: "Dernière connexion", type: "date" },
    { key: "_app_version", label: "Version" },
    // `_mac_wifi` est un nom HISTORIQUE trompeur : le champ ne contient PAS une adresse MAC mais
    // l'IP PUBLIQUE du device, remontée par les players via PUT /setIp (Android: setIp,
    // webapp: reportPublicIp). Le nom de colonne en base est conservé (le parc l'utilise) ;
    // seul le libellé affiché est corrigé.
    { key: "_mac_wifi", label: "IP publique" },
    { key: "_mac_eth", label: "MAC Ethernet" },
    { key: "_tizen_id", label: "Tizen ID" },
    { key: "_client_id", label: "Client ID" },
    { key: "_id_pdv", label: "ID PDV" },
    { key: "_room_id", label: "Room ID" },
    { key: "_video_url", label: "Vidéo URL 1" },
    { key: "_display_id", label: "Display ID" },
    { key: "_zoom", label: "Zoom" },
    { key: "_screen_id", label: "Screen ID" },
    { key: "_limit_notif", label: "Limite Notif" }
];

const DEFAULT_COLUMNS = ["_client_name", "status", "_app_type", "_authorized", "_pin_code", "_end_date", "_last_seen", "_app_version"];

// Statuts de connexion (façon MagicInfo), déduits de _last_seen. Ordre = du plus récent au plus ancien.
const MIN = 60 * 1000, HOUR = 60 * MIN, DAY = 24 * HOUR;
const STATUS_DEFS = [
    { key: "online", label: "En ligne", max: 5 * MIN, dot: "bg-emerald-500", chip: "border-emerald-200 bg-emerald-50 text-emerald-700" },
    { key: "d1", label: "< 24h", max: DAY, dot: "bg-lime-500", chip: "border-lime-200 bg-lime-50 text-lime-700" },
    { key: "d7", label: "< 7 jours", max: 7 * DAY, dot: "bg-amber-500", chip: "border-amber-200 bg-amber-50 text-amber-700" },
    { key: "d30", label: "< 1 mois", max: 30 * DAY, dot: "bg-orange-500", chip: "border-orange-200 bg-orange-50 text-orange-700" },
    { key: "over", label: "> 1 mois", max: Infinity, dot: "bg-rose-500", chip: "border-rose-200 bg-rose-50 text-rose-700" },
];
const statusKey = (lastSeen) => {
    const t = new Date(lastSeen).getTime();
    if (Number.isNaN(t)) return "over";
    const age = Date.now() - t;
    for (const s of STATUS_DEFS) { if (age < s.max) return s.key; }
    return "over";
};
const statusDef = (key) => STATUS_DEFS.find(s => s.key === key) || STATUS_DEFS[STATUS_DEFS.length - 1];

function ListTizenbo() {
    const [datas, setDate] = useState([])
    //const [programme, setProgramme] = useState([])
    const [programmeMap, setProgrammeMap] = useState({});
    const [sortedBy, setSortedBy] = useState('_client_name')
    const [counter, setCounter] = useState(0)
    const [search, setSearch] = useState('');
    const [showModalModify, setShowModalModify] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    const [appTypes, setAppTypes] = useState([]);
    const [selectedAppTypes, setSelectedAppTypes] = useState({});

    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const filterButtonRef = useRef(null);
    const filterMenuRef = useRef(null);

    const [statusFilters, setStatusFilters] = useState(new Set());
    const [visibleColumns, setVisibleColumns] = useState(DEFAULT_COLUMNS);
    const [isColSelectorOpen, setIsColSelectorOpen] = useState(false);
    const colSelectorRef = useRef(null);
    const colButtonRef = useRef(null);
    const [fleetDownloadStatus, setFleetDownloadStatus] = useState({
        totals: { devices: 0, blocked: 0, fallbackCache: 0 },
        blockedDevices: [],
        fallbackCacheDevices: []
    });
    const [isFleetLoading, setIsFleetLoading] = useState(true);

    const [choosenClientBo, setChoosenClientBo] = useState({
        _mac_eth: '',
        _tizen_id: '',
        _pin_code: '',
        _client_name: '',
        _app_type: '',
        _authorized: '',
        _video_url: '',
        _video_url_2: '',
        _video_url_3: '',
        _video_code: '',
        _video_code_2: '',
        _video_code_3: '',
         _end_date: '',
        id: '',
        _app_version: '',
        _zoom: '',
        _display_id: '',
        _client_id: '',
        _room_id: '',
        _id_pdv: '',
        _mac_wifi: '',
        _screen_id: '',
        _limit_notif: '', 
        _unused_videos: '',

    });

    const [devices, setDevices] = useState({
        id: '',
        type: '',
        name: '',
        date: '',
        id_anydesk: '',
        password_anydesk: '',
        id_room_pdv: '',
        remarque: '',
        _pin_code: '',
        id_client: ''
    })
   

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDevice`)
            .then(res => {
                console.log(res.data);
                setDate(res.data.filter((auth) => auth._authorized === 'yes'))
                // setDate(res.data)
            }).catch(err => console.log(err))

        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_device_annuaire_alta`)
            .then(res => {
                setDevices(res.data)
            }).catch(err => console.log(err))
    }, [])

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/gat_all_programme`)
            .then(res => {
                //setProgramme(res.data)

                const map = {};
                res.data.forEach(p => {
                    if (!map[p._pin_code]) {
                        map[p._pin_code] = [];
                    }
                    map[p._pin_code].push(p);
                });
                // console.log("Programmes MAP:", map);

                setProgrammeMap(map);
            }).catch(err => console.log(err))
    }, [])

    useEffect(() => {
        let isMounted = true;
        let eventSource = null;
        let refreshTimer = null;

        const scheduleRefresh = () => {
            if (refreshTimer) return;
            refreshTimer = setTimeout(() => {
                refreshTimer = null;
                fetchFleetStatus();
            }, 1000);
        };

        const fetchFleetStatus = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/download_status/fleet`);
                if (!isMounted) return;
                setFleetDownloadStatus(res.data || {
                    totals: { devices: 0, blocked: 0, fallbackCache: 0 },
                    blockedDevices: [],
                    fallbackCacheDevices: []
                });
            } catch (err) {
                if (!isMounted) return;
                console.error("Erreur récupération suivi fleet:", err);
            } finally {
                if (isMounted) setIsFleetLoading(false);
            }
        };

        setIsFleetLoading(true);
        fetchFleetStatus();

        const streamUrl = `${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/download_status/stream?scope=fleet`;
        try {
            eventSource = new EventSource(streamUrl);
            eventSource.addEventListener('snapshot', () => {
                scheduleRefresh();
            });
            eventSource.addEventListener('download_update', () => {
                scheduleRefresh();
            });
            eventSource.onerror = () => {
                // Fallback polling keeps data fresh.
            };
        } catch (error) {
            console.error("Impossible d'ouvrir le stream SSE fleet:", error);
        }

        // Fallback léger en cas de perte SSE
        const intervalId = setInterval(fetchFleetStatus, 60000);

        return () => {
            isMounted = false;
            clearInterval(intervalId);
            if (refreshTimer) {
                clearTimeout(refreshTimer);
            }
            if (eventSource) {
                eventSource.close();
            }
        };
    }, []);

    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        handleResize(); // set on initial load
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const savedSearch = localStorage.getItem('searchValue');
        if (savedSearch) setSearch(savedSearch);

        const savedFilters = localStorage.getItem('selectedAppFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setSelectedAppTypes(parsedFilters);
            } catch (error) {
                console.error("Erreur lors du chargement des filtres sauvegardés :", error);
                // En cas d'erreur de parse (données corrompues), on nettoie
                localStorage.removeItem('selectedAppFilters');
            }
        }

        const savedColumns = localStorage.getItem('visibleColumns');
        if(savedColumns) {
             try {
                setVisibleColumns(JSON.parse(savedColumns));
            } catch (error) {
                localStorage.removeItem('visibleColumns');
            }
        }
    }, []);

    useEffect(() => {
        if (datas.length > 0) {
            // Utilise Set pour obtenir des valeurs uniques, filtre les valeurs vides (null, undefined, "")
            const uniqueTypes = [...new Set(datas.map(item => item._app_type).filter(Boolean))];
            setAppTypes(uniqueTypes.sort());
        }
    }, [datas]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                isFilterOpen &&
                filterButtonRef.current && !filterButtonRef.current.contains(event.target) &&
                filterMenuRef.current && !filterMenuRef.current.contains(event.target)
            ) {
                setIsFilterOpen(false);
            }

            if (
                isColSelectorOpen &&
                colButtonRef.current && !colButtonRef.current.contains(event.target) &&
                colSelectorRef.current && !colSelectorRef.current.contains(event.target)
            ) {
                setIsColSelectorOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isFilterOpen]);

    useEffect(() => {
        // On sauvegarde l'état des filtres sous forme de chaîne JSON
        localStorage.setItem('selectedAppFilters', JSON.stringify(selectedAppTypes));
    }, [selectedAppTypes]);

    useEffect(() => {
        localStorage.setItem('visibleColumns', JSON.stringify(visibleColumns));
    }, [visibleColumns]);
    
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearch(value);
        localStorage.setItem('searchValue', value);
    };

    const handleAppTypeChange = (e) => {
        const { name, checked } = e.target;
        setSelectedAppTypes(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleResetFilters = () => {
        setSelectedAppTypes({});
        setIsFilterOpen(false); // Optionnel: ferme le menu après réinitialisation
    };

    const handleColumnToggle = (key) => {
        setVisibleColumns(prev => {
            if (prev.includes(key)) {
                // Empêcher de tout désélectionner (garder au moins 1 colonne)
                if(prev.length === 1) return prev; 
                return prev.filter(k => k !== key);
            } else {
                return [...prev, key];
            }
        });
    };

   
    const filteredDatas = datas.filter(dataItem => {

        // --- 1. Logique de filtre par type d'application ---
        const checkedTypes = Object.keys(selectedAppTypes).filter(key => selectedAppTypes[key]);
        let appTypeFilterPassed = true; // Par défaut, on laisse passer (si aucun filtre n'est coché)

        if (checkedTypes.length > 0) {
            // Si au moins une case est cochée, l'item DOIT correspondre
            appTypeFilterPassed = checkedTypes.includes(dataItem._app_type);
        }

        // --- 2. Logique de filtre par recherche (existante) ---
        const normalizedPin = (dataItem._pin_code || "").trim();
        const relatedProgrammes = programmeMap[normalizedPin] || [];
        const searchTerm = search.toLowerCase();


        const has = (v) => String(v ?? '').toLowerCase().includes(searchTerm);

        const clientMatch =
            has(dataItem._client_name) ||
            has(dataItem._client_id) ||
            has(dataItem._id_pdv) ||
            has(dataItem._pin_code) ||
            has(dataItem._mac_wifi) ||       // IP publique du device (remontée par PUT /setIp)
            has(dataItem._room_id) ||        // hash pdv (call-eat)
            has(dataItem._video_code) ||     // id call-eat / codes display price-eat
            has(dataItem._video_code_2) ||
            has(dataItem._video_url) ||
            has(dataItem._video_url_2) ||
            has(dataItem._video_url_3);

        const programmeMatch = relatedProgrammes.some(p =>
            has(p.idPdv) ||                  // id_pdv price-eat présent dans les programmes
            has(p.Videourl1) ||
            has(p.Videourl2) ||
            has(p.Videourl3) ||
            has(p.Videourl4) ||
            has(p.Videourl5)
        );

        const searchFilterPassed = (search === '' || clientMatch || programmeMatch);

        // --- 3. Combinaison des filtres ---
        return searchFilterPassed && appTypeFilterPassed;
    });

    // const TABLE_HEAD = isSmallScreen
    //     ? [
    //         { key: "_client_name", text: "Nom Client" },
    //         { key: "_pin_code", text: "Code PIN" },
    //     ]
    //     : [
    //         { key: "_client_name", text: "Nom Client" },
    //         { key: "_app_type", text: "Type d'app" },
    //         { key: "_authorized", text: "Autorisé" },
    //         { key: "_pin_code", text: "Code PIN" },
    //         { key: "_end_date", text: "Date de fin" },
    //         { key: "_last_seen", text: "Dernière connexion" },
    //         { key: "_app_version", text: "Version" },
    //     ];

    // Compteurs par statut (sur le set filtré recherche+type) + filtre statut
    const statusCounts = filteredDatas.reduce((acc, d) => {
        const k = statusKey(d._last_seen);
        acc[k] = (acc[k] || 0) + 1;
        return acc;
    }, {});
    // Nb de filtres "type d'app" actifs (badge sur le bouton Filtres).
    const activeAppTypeCount = Object.values(selectedAppTypes).filter(Boolean).length;

    const visibleDatas = statusFilters.size > 0
        ? filteredDatas.filter(d => statusFilters.has(statusKey(d._last_seen)))
        : filteredDatas;
    const toggleStatus = (key) => setStatusFilters(prev => {
        const next = new Set(prev);
        next.has(key) ? next.delete(key) : next.add(key);
        return next;
    });

    const sorted = [...visibleDatas].sort((a, b) => {

        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        // if (typeof aVal === "number" && typeof bVal === "number") {
        //     if (counter % 2 === 0) return aVal - bVal;
        //     else return bVal - aVal;
        // }
        // else if (typeof aVal === "string" && typeof bVal === "string") {
        //     if (counter % 2 === 0) return aVal.localeCompare(bVal);
        //     else return bVal.localeCompare(aVal);
        // }
        //return 1;
        if (typeof aVal === "number" && typeof bVal === "number") {
            if (counter % 2 === 0) return aVal - bVal;
            else return bVal - aVal;
        }
        else {
             // Convertir en string pour comparaison sûre
            const aStr = String(aVal);
            const bStr = String(bVal);
            if (counter % 2 === 0) return aStr.localeCompare(bStr);
            else return bStr.localeCompare(aStr);
        }
    });

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // NOTE : rendues via APPEL DIRECT (FilterPopover({...}) et non <FilterPopover/>) — un composant
    // défini DANS le parent change d'identité à chaque render, React le démonte/remonte à chaque
    // coche et le scroll (popover + page) remonte en haut. L'appel direct garde une identité stable.
    const FilterPopover = ({ targetId }) => (
        <div ref={filterMenuRef} className="absolute top-full left-0 z-20 mt-2 w-[30rem] max-w-[90vw] rounded-xl border border-slate-200 bg-white p-4 shadow-xl">
            <div className="mb-3 flex items-center justify-between">
                <h4 className="text-sm font-semibold text-slate-800">
                    Type d'application <span className="font-normal text-slate-400">({appTypes.length})</span>
                </h4>
                <button
                    onClick={handleResetFilters}
                    className="text-xs font-medium text-indigo-600 hover:text-indigo-800"
                >
                    Réinitialiser
                </button>
            </div>
            {/* max-h large + 2 colonnes : tous les types visibles sans crop (scroll seulement si vraiment nécessaire) */}
            <div className={`grid ${isSmallScreen ? 'grid-cols-1' : 'grid-cols-2'} max-h-[26rem] gap-x-4 gap-y-1 overflow-y-auto`}>
                {appTypes.map((type) => (
                    <label
                        key={type}
                        htmlFor={`${targetId}-${type}`}
                        className={`flex cursor-pointer select-none items-center gap-2 rounded-lg px-2 py-1.5 text-sm transition ${selectedAppTypes[type] ? 'bg-indigo-50 text-indigo-700' : 'text-slate-600 hover:bg-slate-50'}`}
                    >
                        <input
                            type="checkbox"
                            id={`${targetId}-${type}`}
                            name={type}
                            checked={selectedAppTypes[type] || false}
                            onChange={handleAppTypeChange}
                            className="h-4 w-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                        />
                        <span className="truncate">{type}</span>
                    </label>
                ))}
            </div>
        </div>
    );


    const ColumnSelectorPopover = () => (
        <div ref={colSelectorRef} className="absolute top-full left-0 z-20 mt-2 max-h-80 w-64 overflow-y-auto rounded-xl border border-slate-200 bg-white p-4 shadow-xl">
            <h4 className="mb-3 text-sm font-semibold text-slate-800">Colonnes affichées</h4>
            <div className="flex flex-col gap-0.5">
                {ALL_COLUMNS.map((col) => (
                    <label
                        key={col.key}
                        htmlFor={`col-${col.key}`}
                        className={`flex cursor-pointer select-none items-center gap-2 rounded-lg px-2 py-1.5 text-sm transition ${visibleColumns.includes(col.key) ? 'bg-indigo-50 text-indigo-700' : 'text-slate-600 hover:bg-slate-50'}`}
                    >
                        <input
                            type="checkbox"
                            id={`col-${col.key}`}
                            checked={visibleColumns.includes(col.key)}
                            onChange={() => handleColumnToggle(col.key)}
                            className="h-4 w-4 cursor-pointer rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                        />
                        {col.label}
                    </label>
                ))}
            </div>
        </div>
    );

    const handleExportExcel = () => {
        // On utilise 'sorted' car il contient déjà les données filtrées (recherche + type d'app)
        const dataToExport = sorted.map(item => {
            const row = {};
            // On boucle sur TOUTES les colonnes disponibles (pas seulement les visibles)
            ALL_COLUMNS.forEach(col => {
                let val = item[col.key];
                
                // Petit formatage pour les dates si nécessaire pour que ce soit lisible dans Excel
                if (col.type === 'date' && val) {
                    val = new Date(val).toLocaleString('fr-FR');
                }
                
                // On utilise le "Label" (Nom Client) comme entête de colonne dans Excel, c'est plus propre
                row[col.label] = val; 
            });
            return row;
        });

        // Création du classeur (Workbook) et de la feuille (Worksheet)
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Liste Filtrée");

        // Génération du nom de fichier avec la date du jour
        const dateStr = new Date().toISOString().split('T')[0];
        XLSX.writeFile(workbook, `Tizen_Export_${dateStr}.xlsx`);
    };

    const renderCellContent = (data, colDef) => {
        if (colDef.key === 'status') {
            const s = statusDef(statusKey(data._last_seen));
            return (
                <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium ${s.chip}`}>
                    <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />{s.label}
                </span>
            );
        }
        const val = data[colDef.key];
        if (val === null || val === undefined) return "";

        if (colDef.type === 'date') {
            return new Date(val).toLocaleString('fr-FR');
        }
        return val;
    };

    const renderCompactDevice = (device) => {
        const title = device.clientName ? `${device.clientName} (${device.pinCode})` : device.pinCode;
        const eta = Number(device?.aggregate?.etaSeconds);
        const etaLabel = Number.isFinite(eta) && eta >= 0
            ? `${Math.floor(eta / 60)}m ${eta % 60}s`
            : "n/a";
        return (
            <div key={`${device.pinCode}-${device.sessionId}`} className="rounded border border-slate-200 bg-white p-2">
                <p className="text-xs font-semibold text-slate-800">{title}</p>
                <p className="text-[11px] text-slate-600">
                    Progression: {Math.round(Number(device?.aggregate?.globalProgress || 0))}% - Failed: {device?.aggregate?.filesFailed || 0} - ETA: {etaLabel}
                </p>
                <p className="text-[10px] text-slate-500">Session: {device?.sessionId || "n/a"}</p>
            </div>
        );
    };

   const ListTable = () => {
        // Obtenir les définitions complètes des colonnes visibles actuellement
        const currentTableCols = ALL_COLUMNS.filter(col => visibleColumns.includes(col.key));

        return (
            <Card className="h-full w-full overflow-x-auto rounded-2xl border border-slate-200 shadow-sm">
                <table className="w-full min-w-max table-auto text-left">
                    <thead>
                        <tr className='sticky top-0'>
                            {isSmallScreen ? (
                                // Header Mobile (fixe)
                                <>
                                    <th className="border-b border-slate-200 bg-slate-50 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500">Client</th>
                                    <th className="border-b border-slate-200 bg-slate-50 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500">Code</th>
                                </>
                            ) : (
                                // --- NOUVEAU : Header Desktop Dynamique ---
                                currentTableCols.map((col) => (
                                    <th
                                        key={col.key}
                                        className="cursor-pointer whitespace-nowrap border-b border-slate-200 bg-slate-50 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                        onClick={() => { setSortedBy(col.key); setCounter(counter + 1) }}
                                    >
                                        <div className="flex items-center gap-1">
                                            {col.label}
                                            {sortedBy === col.key && (
                                                <span className="text-indigo-500">{counter % 2 === 0 ? '▲' : '▼'}</span>
                                            )}
                                        </div>
                                    </th>
                                ))
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.map((data, index) => {
                            const isLast = index === data.length - 1;
                            const classes = isLast ? "px-4 py-3" : "px-4 py-3 border-b border-slate-100";

                            // Fonction pour ouvrir le modal (factorisée)
                            const handleRowClick = () => {
                                setShowModalModify(true);
                                // On passe toutes les infos de 'data' dans choosenClientBo
                                setChoosenClientBo({ ...choosenClientBo, ...data });
                            };

                            return (
                                <tr key={data.id} onClick={handleRowClick} className="cursor-pointer transition-colors hover:bg-indigo-50/40">
                                    {isSmallScreen ? (
                                        // Rendu Mobile (Fixe)
                                        <>
                                            <td className={classes}>
                                                <Typography variant="small" color="blue-gray" className="font-normal">
                                                    {data._client_name}
                                                </Typography>
                                            </td>
                                            <td className={classes}>
                                                <Typography variant="small" color="blue-gray" className="font-normal">
                                                    {data._pin_code}
                                                </Typography>
                                            </td>
                                        </>
                                    ) : (
                                        // --- NOUVEAU : Rendu Desktop Dynamique ---
                                        currentTableCols.map((col) => (
                                            <td key={`${data.id}-${col.key}`} className={classes}>
                                                <Typography variant="small" color="blue-gray" className="font-normal">
                                                    {renderCellContent(data, col)}
                                                </Typography>
                                            </td>
                                        ))
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className="flex items-center justify-end border-t border-slate-100 bg-slate-50 px-4 py-3">
                    <span className="text-sm font-medium text-slate-600">
                        Total : {visibleDatas.length} {visibleDatas.length > 1 ? 'éléments affichés' : 'élément affiché'}
                    </span>
                </div>
            </Card>
        );
    };

    return (
        <Fragment>
            <div>
                {/* La partie Mobile Header reste similaire, j'ajoute le bouton colonnes seulement sur Desktop pour l'instant pour ne pas surcharger le mobile */}
                {isSmallScreen ? (
                    <Fragment>
                        <div className='flex justify-between text-center mx-2 my-4 gap-2'>
                             <div className="relative">
                                <button
                                    ref={filterButtonRef}
                                    onClick={() => setIsFilterOpen(!isFilterOpen)}
                                    className="h-9 px-3 py-2 bg-slate-700 text-white rounded-lg flex items-center"
                                >
                                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c-1.1 0-2 .9-2 2v1.17a3 3 0 01-.88 2.12L4.5 13.5V18a1 1 0 001 1h13a1 1 0 001-1v-4.5l-4.62-5.21A3 3 0 0114 6.17V5a2 2 0 00-2-2z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 18h4" />
                                    </svg>
                                </button>
                                {isFilterOpen && FilterPopover({ targetId: "filter-sm" })}
                            </div>
                            <div className=" flex place-items-end w-1/2 h-9 rounded-lg focus-within:shadow-lg bg-slate-700 overflow-hidden">
                                <div className="grid place-items-center h-full w-12 text-slate-50">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>
                                <input
                                    className="h-full w-full outline-none text-white pr-2 bg-slate-700 placeholder-slate-50"
                                    type="text"
                                    id="search"
                                    placeholder="Search.."
                                    value={search}
                                    onChange={handleSearchChange} />
                            </div>
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                    <div className="mx-auto mb-1 mt-4 flex max-w-[95rem] items-end justify-between px-4">
                        <div>
                            <h1 className="text-xl font-semibold text-slate-800">Écrans approuvés</h1>
                            <p className="text-sm text-slate-500">
                                {visibleDatas.length} écran{visibleDatas.length > 1 ? 's' : ''} affiché{visibleDatas.length > 1 ? 's' : ''} sur {datas.length}
                            </p>
                        </div>
                    </div>
                    <div className='mx-auto my-2 flex max-w-[95rem] items-center gap-2 px-4'>
                        <ListToggle />

                        {/* Bouton Filtres */}
                        <div className="relative">
                            <button
                                ref={filterButtonRef}
                                onClick={() => setIsFilterOpen(!isFilterOpen)}
                                className={`flex h-9 items-center gap-2 whitespace-nowrap rounded-lg border px-4 text-sm font-medium shadow-sm transition ${activeAppTypeCount > 0 ? 'border-indigo-300 bg-indigo-50 text-indigo-700' : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'}`}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c-1.1 0-2 .9-2 2v1.17a3 3 0 01-.88 2.12L4.5 13.5V18a1 1 0 001 1h13a1 1 0 001-1v-4.5l-4.62-5.21A3 3 0 0114 6.17V5a2 2 0 00-2-2z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M10 18h4" />
                                </svg>
                                Filtres
                                {activeAppTypeCount > 0 && (
                                    <span className="grid h-5 min-w-[1.25rem] place-items-center rounded-full bg-indigo-600 px-1 text-[11px] font-bold text-white">
                                        {activeAppTypeCount}
                                    </span>
                                )}
                            </button>
                            {isFilterOpen && FilterPopover({ targetId: "filter-lg" })}
                        </div>

                        {/* --- NOUVEAU : Bouton Colonnes --- */}
                        <div className="relative">
                            <button
                                ref={colButtonRef}
                                onClick={() => setIsColSelectorOpen(!isColSelectorOpen)}
                                className="flex h-9 items-center gap-2 whitespace-nowrap rounded-lg border border-slate-200 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z" />
                                </svg>
                                Colonnes
                            </button>
                            {isColSelectorOpen && ColumnSelectorPopover()}
                        </div>

                        <button
                            onClick={handleExportExcel}
                            className="flex h-9 items-center gap-2 whitespace-nowrap rounded-lg bg-emerald-600 px-4 text-sm font-medium text-white hover:bg-emerald-700 transition-colors"
                            title="Télécharger en Excel"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m13.5 0v-1.5c0-.621-.504-1.125-1.125-1.125m-9.75 0V5.625m0 7.5l3-3m0 0l3 3m-3-3v7.5M16.5 13.5V5.625" />
                                {/* Ou une icône plus "Excel" si vous préférez */}
                            </svg>
                            Excel
                        </button>

                        {/* Barre de recherche */}
                        <div className="relative flex h-9 w-full items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input
                                className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                                type="text"
                                id="search"
                                placeholder="Nom, PIN, id_pdv, id calleat, programme…"
                                value={search}
                                onChange={handleSearchChange} />
                        </div>
                    </div>
                    </Fragment>
                )}

                {/* Filtres par statut de connexion (façon MagicInfo) */}
                <div className="mx-auto mt-2 flex max-w-[95rem] flex-wrap items-center gap-2 px-4">
                    <span className="text-xs font-semibold uppercase tracking-wide text-slate-400">Statut</span>
                    <button
                        type="button"
                        onClick={() => setStatusFilters(new Set())}
                        className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition ${statusFilters.size === 0 ? 'border-indigo-300 bg-indigo-50 text-indigo-700' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50'}`}
                    >
                        Tous ({filteredDatas.length})
                    </button>
                    {STATUS_DEFS.map(s => {
                        const active = statusFilters.has(s.key);
                        return (
                            <button
                                key={s.key}
                                type="button"
                                onClick={() => toggleStatus(s.key)}
                                className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition ${active ? s.chip + ' ring-2 ring-indigo-200' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50'}`}
                            >
                                <span className={`h-2 w-2 rounded-full ${s.dot}`} />
                                {s.label}
                                <span className="opacity-70">({statusCounts[s.key] || 0})</span>
                            </button>
                        );
                    })}
                </div>

                <main className="flex flex-row mt-4">
                    <div className="w-full">
                        <div className="mb-3 rounded-lg border border-slate-200 bg-white p-3 shadow-sm">
                            <h3 className="text-sm font-semibold text-slate-800">Suivi Download Fleet</h3>
                            {isFleetLoading ? (
                                <p className="mt-2 text-xs text-slate-500">Chargement...</p>
                            ) : (
                                <div className="mt-2">
                                    <div className="mb-2 grid grid-cols-1 gap-2 text-xs md:grid-cols-3">
                                        <div className="rounded border border-slate-200 bg-slate-50 p-2">Devices suivis: {fleetDownloadStatus?.totals?.devices || 0}</div>
                                        <div className="rounded border border-red-200 bg-red-50 p-2 text-red-700">Devices bloqués: {fleetDownloadStatus?.totals?.blocked || 0}</div>
                                        <div className="rounded border border-teal-200 bg-teal-50 p-2 text-teal-700">Fallback cache: {fleetDownloadStatus?.totals?.fallbackCache || 0}</div>
                                    </div>
                                    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                                        <div>
                                            <p className="mb-1 text-xs font-semibold text-slate-700">Devices bloqués</p>
                                            <div className="max-h-28 space-y-1 overflow-auto">
                                                {(fleetDownloadStatus?.blockedDevices || []).length > 0
                                                    ? (fleetDownloadStatus.blockedDevices || []).map(renderCompactDevice)
                                                    : <p className="text-[11px] text-slate-500">Aucun device bloqué.</p>}
                                            </div>
                                        </div>
                                        <div>
                                            <p className="mb-1 text-xs font-semibold text-slate-700">Devices en fallback cache</p>
                                            <div className="max-h-28 space-y-1 overflow-auto">
                                                {(fleetDownloadStatus?.fallbackCacheDevices || []).length > 0
                                                    ? (fleetDownloadStatus.fallbackCacheDevices || []).map(renderCompactDevice)
                                                    : <p className="text-[11px] text-slate-500">Aucun fallback cache.</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {ListTable()}
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6 cursor-pointer bg-white rounded-full p-1 shadow-md" onClick={() => scrollToTop()}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </main>
            </div>
            <ModalModifyTizenbo isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenClientBo={choosenClientBo} devices={devices} />
        </Fragment >
    );
}
export default ListTizenbo;
